import { render } from "./PDFInstalador.vue?vue&type=template&id=5c5f9584&scoped=true"
import script from "./PDFInstalador.vue?vue&type=script&lang=js"
export * from "./PDFInstalador.vue?vue&type=script&lang=js"

import "./PDFInstalador.vue?vue&type=style&index=0&id=5c5f9584&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5f9584"]])

export default __exports__